import * as React from "react";
import * as ReactDOM from "react-dom";
import { Tooltip } from "./Tooltip";
import { TooltipData } from "./data";
/**
 * Tooltip API appends only one instance of <Tooltip /> component into DOM and
 * provides methods for
 * - setting data attribute that is used to show the tooltip messages
 * - forcing refresh of the tooltip message
 *
 * @returns object
 * @public setMessage(message?: string): object
 * @example
 * import { TooltipApi } from "sb-resp-ui";
 *
 * export class MyComponent extends React.Component<{}, {}> {
 *  render() {
 *      return (
 *          <div {...TooltipApi.getInstance().setMessage("Hello World!")} />
 *      );
 *  }
 * }
 */
var TooltipApi = /** @class */ (function () {
    function TooltipApi() {
        this.placeholderID = "rj-tooltip-placeholder";
        if (!TooltipApi.instance) {
            TooltipApi.instance = this;
            this.createHolder();
        }
        return TooltipApi.instance;
    }
    TooltipApi.getInstance = function () {
        return TooltipApi.instance || new TooltipApi();
    };
    TooltipApi.prototype.createHolder = function () {
        var placeholder = document.getElementById(this.placeholderID);
        /* istanbul ignore next */
        if (!placeholder && document.body) {
            placeholder = document.createElement("div");
            placeholder.id = this.placeholderID;
            document.body.appendChild(placeholder);
        }
        return ReactDOM.render(React.createElement(Tooltip), placeholder);
    };
    TooltipApi.prototype.setMessage = function (message) {
        if (message === void 0) { message = ""; }
        return {
            "data-tooltip-message": message
        };
    };
    TooltipApi.prototype.refresh = function (target) {
        if (target.nodeType === 1 && target.dataset && target.dataset.tooltipMessage) {
            TooltipData.getInstance.changeMessage(target.dataset.tooltipMessage);
        }
    };
    return TooltipApi;
}());
export { TooltipApi };
//# sourceMappingURL=TooltipApi.js.map